import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";

type SubmenuItem = {
  to: string;
  label: string;
};

type Props = {
  to: string;
  icon: ReactNode;
  label: string;
  middleMenu?: boolean;
  submenu?: SubmenuItem[];
  openKey?: string;
  setOpenKey: (key: string) => void;
};

const ListItemLink = ({
  to,
  icon,
  label,
  middleMenu,
  submenu,
  openKey,
  setOpenKey,
}: Props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const hasSubmenu = !!submenu?.length;

  const isSelected = location.pathname.includes(to);

  const isOpen = openKey === to;

  const handleClick = () => {
    if (hasSubmenu) {
      setOpenKey(isOpen ? "" : to);
    } else {
      setOpenKey("");
      navigate(to);
    }
  };
  return (
    <>
      <ListItemButton
        onClick={handleClick}
        sx={{
          flexDirection: middleMenu ? "column" : "row",
          borderRadius: 2,
          mt: 1,
          mb: 1,
          backgroundColor: isSelected ? "primary.main" : "",
          color: isSelected ? "#fff" : "inherit",
        }}
      >
        <ListItemIcon sx={{ minWidth: middleMenu ? "0px" : "32px" }}>
          {icon}
        </ListItemIcon>
        {!middleMenu && <ListItemText primary={label} />}
        {!middleMenu &&
          hasSubmenu &&
          (isOpen ? <ExpandLess /> : <ExpandMore />)}
      </ListItemButton>

      {hasSubmenu && (
        <Collapse in={isOpen && !middleMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {submenu.map((item) => (
              <ListItemButton
                key={item.to}
                onClick={() => navigate(item.to)}
                sx={{
                  pl: 4,
                  borderRadius: 2,
                  backgroundColor: location.pathname.includes(item.to)
                    ? "#5600ac"
                    : "",
                  color: location.pathname === item.to ? "#fff" : "inherit",
                }}
              >
                <ListItemText primary={item.label} />
              </ListItemButton>
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
};

export default ListItemLink;
